<template>
  <div>
    <step :navItems="navItems" :index="1" :step="step" v-on:step="updateStep" v-on:back="() => { this.$router.push('/group-mgr') }">
      <template slot="header">
        <h3>班級名稱</h3>
      </template>

      <template slot="body">
        <div class="row">
          <div class="col-sm-4 offset-sm-4">
            <form class="form-custom pt-0 bg-white">
              <label for="inputOldPassword" class="sr-only">班級名稱</label>
              <input type="text" class="form-control mt-3 rounded" :placeholder="'請輸入名稱...(限制10個字)'" required v-model="name">
            </form>
          </div>
        </div>
      </template>
    </step>

    <step :navItems="navItems" :index="2" :step="step" v-on:step="updateStep">
      <template slot="header">
        <div class="row">
          <div class="col-sm-4 offset-sm-4" style="font-size: 24px;">{{ name }}</div>
          <div class="col-sm-4">
            <switch-button v-on:status="(status) => { this.switchOn = status }" leftLabel="學生清單" rightLabel="已選學生" />
          </div>
        </div>
      </template>

      <template slot="body">
        <div class="row mt-3">
          <div class="col-8 offset-2">
            <ul class="list-group list-group-flush">
              <li class="list-group-item border text-left mb-3 rounded"
                :class="{ 'active': getSelectedIdx(item.id) > -1 }"
                style="line-height: 150%;"
                v-for="item in students"
                @click="edit(item)">
                <div class="float-left">
                  <span>{{ item.realName }}</span><br>{{ item.userName }}
                </div>
              </li>
            </ul>

            <pagination class="mt-3" :current="pageIndex" :total="pageCount" v-on:page="updatePage" v-if="switchOn" />
          </div>
        </div>
      </template>
    </step>

    <step :navItems="navItems" :index="3" :step="step" v-on:step="updateStep" v-on:finish="() => { this.$router.push('/group-mgr') }">
      <template slot="header">
        <h3>完成</h3>
      </template>

      <template slot="body">
        <div class="col-8 offset-2">
          <ul class="list-group list-group-flush">
            <li class="list-group-item border text-left mb-3 rounded"
              style="line-height: 150%;">
              <span>
                {{ name }}<br>建立時間：{{ '2019-01-01 00:00' }}
              </span>
              <span class="float-right">
                共 {{ selected.length }} 位學生
              </span>
            </li>
          </ul>
        </div>
      </template>
    </step>
  </div>
</template>

<script>
import lessonFilterMixin from '../../components/lessonFilterMixin'
import langMixin from '../../components/langMixin'
import Pagination from '../../components/Pagination'
import Step from './Step'
import api from '../../store/api'
import selectMixin from './selectMixin'
import SwitchButton from './SwitchButton'

export default {

  name: 'TeachingGroupEditor',

  components: {
    Pagination,
    Step,
    SwitchButton
  },

  mixins: [lessonFilterMixin, langMixin, selectMixin],

  data () {
    return {
      groupId: null,
      step: 1,
      switchOn: true,
      name: '',
      navItems: ['新增或選擇清單', '輸入名稱', '選擇學生', '完成'],
      list: [],
      pageIndex: 1,
      pageCount: 0
    }
  },

  computed: {
    mode () {
      return (this.$route.name === 'group-mgr.add') ? 'add' : 'edit'
    },

    students () {
      return this.switchOn ? this.list : this.selected
    }
  },

  async mounted () {
    this.groupId = this.$route.params.groupId
    this.getList()

    if (this.groupId) {
      const { data } = await api.get('/GroupMgr/TeachingGroups/' + this.groupId)

      if (data.status === 'OK') {
        this.name = data.data.name

        let self = this
        api.get('/GroupMgr/TeachingGroups/' + this.groupId + '/students')
          .then((res) => {
            self.selected = res.data.data || []
          })
      }
    }
  },

  methods: {
    async getList (params) {
      const { data } = await api.get('/StudentMgr/Students', { params: params })

      if (data.status === 'OK') {
        this.list = data.data
        this.pageIndex = data.pageIndex
        this.pageCount = data.pageCount
      }
    },

    updatePage (page) {
      this.getList({
        'pageIndex': page
      })
    },

    updateStep (step) {
      if (step === 3 && this.mode === 'add') {
        this.add()
      } else if (step === 2 && this.groupId) {
        this.updateName()
      }

      this.step = step
    },

    async add () {
      let fileData = new window.FormData()
      fileData.append('name', this.name)

      const { data } = await api.post('/GroupMgr/TeachingGroups', fileData)

      if (data.status === 'OK') {
        this.groupId = data.data.id
        this.addStudentToGorup()
      }
    },

    async updateName () {
      let fileData = new window.FormData()
      fileData.append('name', this.name)

      const { data } = await api.patch('/GroupMgr/TeachingGroups/' + this.groupId, fileData)

      if (data.status === 'OK') {
        console.log('Update Name Success')
      }
    },

    async addStudentToGorup () {
      let groupForm = new window.FormData()
      groupForm.append('studentIds', this.selected)

      const { data } = await api.post('/GroupMgr/TeachingGroups/' + this.groupId + '/Students', groupForm)

      if (data.status === 'OK') {
        console.log('Success')
      }
    },

    async edit (item) {
      if (this.mode === 'add') {
        this.select(item)
        return
      }

      let action = (this.getSelectedIdx(item.id) > -1) ? 'delete' : 'post'
      let formData = new window.FormData()
      formData.append('studentIds', [item.id])

      if (action === 'delete') {
        formData = {
          data: formData
        }
      }

      const { data } = await api[action]('/GroupMgr/TeachingGroups/' + this.groupId + '/Students', formData)

      if (data.status === 'OK') {
        this.select(item)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/style/color.scss';

.list-group-item.active {
  background-color: $main-color;
}
</style>


// WEBPACK FOOTER //
// TeachingGroupEditor.vue?34c4af2b